import React from "react";
import styled from "styled-components";

export default function RankPointInput(props) {
  const { isEdit, value, setValue, placeholder } = props;

	function handleChange(e) {
    const input = e.target.value;
    const onlyNumbers = input.replace(/[^0-9]/g, ''); // 숫자 외 문자 제거
    const limited = onlyNumbers.slice(0, 3); // 최대 3자리까지만 허용
    
    setValue(limited);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
	}

  return (
    <InputView border={isEdit ? '2px dashed #909090' : '2px solid #909090'}>
      <Input
        placeholder={placeholder}
        value={value}
        type='text'
        disabled={!isEdit}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </InputView>
  )
}

const InputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 7px 15px;

  width: calc(100% - 32px);

  border: ${props => props.border};
  border-radius: 30px;
  background-color: #2F2F32;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 17px;

	width: 100%;
	height: 17px;

	padding: 0 0 0 0;
	margin: 0 0 0 0;

	outline: none;
	
	color: #FFFFFF;

  border: none;
  background-color: #2F2F32;

	::placeholder {
		color: #6A6A6C;
	}
  
  transition: all 0.3s ease-in-out;
`;